export const BOOKING_SEARCH_RESULT_STATUS_EMPTY_STATE = 'EMPTY_STATE';
export const BOOKING_SEARCH_RESULT_STATUS_SUCCESSFUL = 'SUCCESSFUL';
export const BOOKING_SEARCH_RESULT_STATUS_UNKNOWN_FAILURE = 'UNKNOWN_FAILURE';
